import { abyssColors } from '@/theme/colors';
import { Box, Typography, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogDescription = styled(Typography)({
  marginBottom: '1.6rem',
  paddingLeft: '2.4rem',
  paddingRight: '2.4rem',
  fontSize: '1.4rem',
  color: abyssColors.primary[400],
  fontWeight: 400,
});

export const FileTypeRadioBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 0,
});

export const StyledFormControlLabel = styled(FormControlLabel)({
  marginLeft: 0,
  paddingLeft: '2.4rem',
  paddingRight: '2.4rem',
  paddingTop: '0.96rem',
  paddingBottom: '0.96rem',
  width: '100%',
  margin: 0,
});

export const BorderedFormControlLabel = styled(FormControlLabel)({
  marginLeft: 0,
  paddingLeft: '2.4rem',
  paddingRight: '2.4rem',
  paddingTop: '0.96rem',
  paddingBottom: '0.96rem',
  width: '100%',
  margin: 0,
  borderTop: '1px solid #e0e0e0',
  borderBottom: '1px solid #e0e0e0',
});

export const FileTypeLabelBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const DialogActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '1.2rem',
  paddingLeft: '2.4rem',
  paddingRight: '2.4rem',
  paddingTop: '1.6rem',
  paddingBottom: '1.6rem',
});

export const genericModalStyles = {
  crossIconStyle: {
    backgroundColor: 'transparent',
    color: 'text.secondary',
    fontSize: '1.5rem',
    mt: 0.5,
    mr: 0.5,
  },
  sx: {
    left: 'calc(50% - 275px) !important',
    top: '27rem',
    width: 520,
    height: '31rem',
  },
  titleSx: { fontWeight: 600, fontSize: '2rem', color: abyssColors.primary[500] },
  headerStyleProp: {
    alignItems: 'center',
    px: 3,
    py: 2,
    pb: 0,
    minHeight: 40,
  },
};
